import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_cf402a0d: FaireBrandEntity = {
  token: "b_cf402a0d",
  type: "brand",
  name: "Noodle & Boo, Inc.",
  avatarUrl:
    "https://cdn.faire.com/fastly/67f7318ce4f8bc139c187ef0098163636d35327baeba068fe76fd5b79ddf800e.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/f4cebb45772a7d3b9a4a4e8e36198df1a179ea6229ae5a0647d06761085d9977.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/67f7318ce4f8bc139c187ef0098163636d35327baeba068fe76fd5b79ddf800e.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f4cebb45772a7d3b9a4a4e8e36198df1a179ea6229ae5a0647d06761085d9977.jpeg",
  location: "Los Gatos, CA, USA",
  minimumOrderDollars: 235,
  rating: 5,
  reviewCount: 29,
  isInsider: true,
  description:
    "My heart is filled with gratitude...\nfor our steadfast retailers and our newest retailers as I reflect on the last 20 years.\n\nI founded Noodle & Boo as a young mom who simply wanted to create products that were safe, worked especially well for sensitive skin and were luxurious to use.\n\nEvery time we touch our babes it brings us closer and strengthens our bond. Our goal was to elevate, and make special, daily routines by creating delightful products. Our purpose was equally important; to use a portion of every sale to help children in need. Our mission is (and always has been) “pure love” for families, and “littles” who need our support the most.\n\nWe are still a small, woman-owned company. Every product is made in the United States. We continue to donate every month to worthy non-profits who share our vision.\n\nIt is humbling to be recognized as a trusted leader in personal and home care products. We continue to strive for excellence in everything we do.\n\nThank you for your partnership in bringing Noodle & Boo to your customers, helping us to realize our vision and positively impacting the lives of children around the world.\n\nAs always, I welcome your thoughts and feedback.\nSincerely,\nChristine Burger\n\n",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:29.771Z",
    importedBy: "entity-db-cli",
  },
};
